import { defaultHttpClient } from 'shared/src/api/httpClient';
import type { PostFavoriteMarketParams } from './types';
import type { ResponseFavoriteMarket } from '../types';

/**
 * - 마켓 favorite
 */
export const postFavoriteMarket = ({ sno }: PostFavoriteMarketParams) => {
  return defaultHttpClient.request<ResponseFavoriteMarket>({
    method: 'POST',
    url: `/api/v2/markets/${sno}/favorite`,
  });
};
